import accordionRangeGroupTemplate from './accordion_range_group.html';

/***
 * @ngdoc directive
 * @name BB:bbAccordionRangeGroup
 * @restrict AE
 * @scope true
 *
 * @description
 *
 * Use to group TimeSlot's by specified range for use with AngularUI Bootstrap accordion control
 *
 * <pre>
 * restrict: 'AE'
 * replace: true
 * scope: true
 * </pre>
 *
 * @param {hash} bbAccordionRangeGroup  A hash of options
 * @property {boolean} collapse_when_time_selected Collapse when time is selected
 * @property {string} setRange Set time range for start and end
 * @property {string} start_time The start time
 * @property {string} end_time The end time
 * @property {array} accordion_slots The accordion slots
 * @property {boolean} is_open Time is open
 * @property {boolean} has_availability Group has have availability
 * @property {boolean} is_selected Group is selected
 * @property {string} source_slots Source of slots
 * @property {boolean} selected_slot Range group selected slot
 * @property {boolean} hideHeading Range group hide heading
 */

angular.module('BBPublicBooking').directive('bbAccordionRangeGroup', () => {
    return {
        restrict: 'AE',
        replace: false,
        scope: {
            day: '=',
            slots: '=',
            selectSlot: '=',
            disabled_slot: '=disabledSlot'
        },
        controller: 'AccordionRangeGroup',
        link(scope, element, attrs) {
            addFocusOnlyOnPressingTabFunctionality(scope, element);
            return scope.options = scope.$eval(attrs.bbAccordionRangeGroup) || {};
        },
        templateUrl(element, attrs) {
            return accordionRangeGroupTemplate.id;
        }
    };

    /***
     * @ngdoc function
     * @name addFocusOnlyOnPressingTabFunctionality
     *
     * @description
     * Adds listeners to accordion group detecting if mouse was clicked. It adds special tab-focused class to
     * element only if focus what obtained in another way.
     */
    function addFocusOnlyOnPressingTabFunctionality(scope, element) {
        let wasElementClicked = false;

        element.mousedown(() => wasElementClicked = true);
        element.mouseup(() => wasElementClicked = false);

        element.focusin((event) => {
            if (!wasElementClicked && event.target.localName !== 'li') {
                // 1. Mark as focused only in case the element wasn't clicked before.
                // 2. Do not focus element when event was meant to be delivered to its child element.
                element.find('div.panel-heading[role="tab"]').addClass('tab-focused');
            }
        });

        element.focusout(() => {
            element.find('div.panel-heading[role="tab"]').removeClass('tab-focused');
        });

        // Clearing DOM from redundant binding.
        scope.$on('$destroy', () => element.off());
    }
});



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/accordion-range-group/bb_accordion_range_group.directive.js